import React, { Fragment, useEffect, useState, useCallback } from "react";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactModal from "react-modal";
import AgregarVisitaEvaluador from "./AgregarVisitaEvaluador";
import EditarVisita from "./EditarVisita";
import { Link } from "react-router-dom";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Cookies from "universal-cookie";
function AgendarVisita(props) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [list, setList] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const cookie = new Cookies();
  const handleOpenModalTest = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  // 🔥 FUNCIÓN CENTRAL PARA RECARGAR LA TABLA
  const fetchVisitas = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `https://suadesarrollo.azurewebsites.net/api/ObtenerVisitaEvaluadorPorSolicitudIdEvaluadorId?SolicitudId=${props.idSolicitud}&EvaluadorId=${props.idEvaluador}`,
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
        },
      );
      setList(response.data);
    } catch (error) {
      console.error("Error cargando visitas", error);
    } finally {
      setLoading(false);
    }
  }, [props.idSolicitud, props.idEvaluador]);

  useEffect(() => {
    if (modalIsOpen) {
      fetchVisitas();
    }
  }, [modalIsOpen, fetchVisitas]);
  const generarPdf = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        `https://suadesarrollo.azurewebsites.net/api/GenerarPdfVisitaEvaluador/${cookie.get("id")}/${props.idSolicitud}`,
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
          responseType: "blob",
        },
      );

      const file = new Blob([response.data], {
        type: "application/pdf",
      });

      const fileURL = URL.createObjectURL(file);

      window.open(fileURL, "_blank");

      setTimeout(() => {
        URL.revokeObjectURL(fileURL);
      }, 10000);
    } catch (error) {
      console.error("Error generando PDF", error);
      alert("No fue posible generar el PDF.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <Fragment>
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id="tooltip-horario">Información agenda del Líder</Tooltip>
        }
      >
        <button className="btn btn-dark" onClick={handleOpenModalTest}>
          Agenda
        </button>
      </OverlayTrigger>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        ariaHideApp={false}
        contentLabel="Agenda"
      >
        <div className="container">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">Agenda</h6>
            </div>

            <div className="card-body">
              <center>
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  inline
                />
              </center>

              <hr />

              {/* 🔥 AQUÍ CONECTAMOS EL REFRESH */}
              <AgregarVisitaEvaluador
                idS={props.idSolicitud}
                idE={props.idEvaluador}
                onSuccess={fetchVisitas}
              />
              <div className="text-center mt-4">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={generarPdf}
                  disabled={loading}
                >
                  {loading ? "Generando PDF..." : "Generar PDF"}
                </button>
              </div>
              <hr />

              <div className="table-responsive">
                {loading ? (
                  <p className="text-center">Cargando agenda...</p>
                ) : (
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>Objetivo</th>
                        <th>Actividades</th>
                        <th>Observaciones</th>
                        <th>Fecha inicial</th>
                        <th>Fecha final</th>
                        <th>Evaluador</th>
                        <th>Editar</th>
                      </tr>
                    </thead>
                    <tbody>
                      {list.length === 0 ? (
                        <tr>
                          <td colSpan="8" className="text-center">
                            No hay visitas registradas
                          </td>
                        </tr>
                      ) : (
                        list.map((item) => {
                          const fechaIni = new Date(
                            item.fechaInicial,
                          ).toLocaleString("es-ES");
                          const fechaFin = new Date(
                            item.fechaFinal,
                          ).toLocaleString("es-ES");

                          return (
                            <tr key={item.id}>
                              <td>{item.id}</td>
                              <td>{item.objetivo}</td>
                              <td>{item.actividad}</td>
                              <td>{item.observaciones}</td>
                              <td>{fechaIni}</td>
                              <td>{fechaFin}</td>
                              <td>{item.evaluadorId}</td>
                              <td>
                                <EditarVisita
                                  idVisita={item.id}
                                  objetivo={item.objetivo}
                                  actividad={item.actividad}
                                  observaciones={item.observaciones}
                                  fechaInicialProp={item.fechaInicial}
                                  fechaFinalProp={item.fechaFinal}
                                  onSuccess={fetchVisitas}
                                />
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </Fragment>
  );
}

export default AgendarVisita;
